export const TipoPessoaEnum = Object.freeze({
    PessoaFisica: 0,
    PessoaJuridica: 1,
    PessoaFisicaEstrangeira: 2,
    PessoaJuridicaEstrangeira: 3,
});